/* eslint-disable */
export enum BUSINESS_UNITS {
	STUDY_ACADEMY = 1,
	NEO_STUDY = 2,
	NOVA_STUDY = 3,
	MONGOLIA = 4,
	STUDY_ACADEMY_HIGH_SCHOOL = 5,
	STUDY_ACADEMY_HIGH_SCHOOL_ODESSA = 6,
	TIS = 7,
	IT_ACADEMY = 8,
	TRAINING_CENTER = 9,
}
